//---------------------------------------------------
// Settings
//---------------------------------------------------
var settings = {}

// The program version to show on the About
settings.version = "1.01";

// env: [testcore|testugm|prodcore|produgm]
//     testcore - test enviroment to ShadesMasterWebAPI
//     testugm  - test enviroment to ugmfree.local
//     produgm  - production enviroment to www.ugmfree.it

var settings_env = function () {
	// Check the webpack DefinePlugin __ENV__ value to understand the environment.
	// If it's not defined, it assumes it's the development environment because webpack does nothing for the dev env.
	if (typeof __ENV__ == 'undefined')
		return 'testugm';
	else 
		return __ENV__;
} 

// apiEndPoint: it's the end point to call the web api for any env
settings.apiEndPoint = '';

switch (settings_env()) {
	case "testcore":
		settings.apiEndPoint = 'http://shadesmastercoloringwebapi/';
		break;
	case "testugm":
		settings.apiEndPoint = "https://ugmfree.local/api/shadesmaster/";
		break;
	case "produgm":
		settings.apiEndPoint = "https://www.ugmfree.it/api/shadesmaster/";
		break;
}

export default settings;